<app-ff-cabinet-head
  [titleKey]="activeTab === 'deals' ? 'freightForwarder.dashboard.dealsTab' : 'freightForwarder.dashboard.bidsTab'"
  [titleFallback]="activeTab === 'deals' ? 'Мои сделки' : 'Мои ставки'"
></app-ff-cabinet-head>

<!-- Вкладка «Мои ставки» -->
<section *ngIf="activeTab === 'bids'" class="pp-card">
  <div *ngIf="loadingBids" class="pp-loading">{{ loadingText }}</div>
  <div *ngIf="errorBids" class="pp-error">{{ errorBids }}</div>
  <div *ngIf="!loadingBids && !errorBids && bids.length === 0" class="pp-empty">{{ noBidsText }}</div>

  <ng-container *ngIf="!loadingBids && !errorBids && bids.length > 0">
    <!-- Быстрый фильтр по статусу -->
    <div class="bid-filter" role="tablist">
      <button type="button" *ngFor="let f of bidFilters" role="tab" class="bid-filter__chip"
              [class.is-active]="bidFilter === f.key" [attr.aria-selected]="bidFilter === f.key" (click)="bidFilter = f.key">
        {{ f.label }} <span>{{ bidCount(f.key) }}</span>
      </button>
    </div>

    <div class="pp-table-wrap">
      <table class="pp-table bids-table" appResizableColumns="ff-bids">
        <thead>
          <tr>
            <th>{{ bidNumberText }}</th>
            <th>{{ t('ffDash.requestRoute', 'Запрос и маршрут') }}</th>
            <th>{{ priceText }}</th>
            <th>{{ deliveryDaysText }}</th>
            <th>{{ statusText }}</th>
            <th>{{ t('ffDash.sentAt', 'Отправлена') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bid of filteredBids" class="bid-row" [class.is-dead]="isRequestGone(bid.cargoRequestId)"
              (click)="openBidRow(bid)">
            <td class="pp-num pp-nowrap">{{ bid.id | docNo:'B':bid.createdAt }}</td>
            <td class="route-cell">
              <small>{{ bid.cargoRequestId | docNo:'R':requestCreatedAt(bid) }}</small>
              <ng-container *ngIf="requests[bid.cargoRequestId] as r; else noRoute">
                <strong [attr.title]="r.fromCity + ' → ' + r.toCity">{{ r.fromCity }} → {{ r.toCity }}</strong>
                <span>{{ countryName(r.fromCountryId) }} → {{ countryName(r.toCountryId) }}</span>
              </ng-container>
              <ng-template #noRoute>
                <span class="route-cell__gone" *ngIf="isRequestGone(bid.cargoRequestId)">{{ t('ffDash.requestGone', 'Запрос удалён клиентом') }}</span>
                <span *ngIf="!isRequestGone(bid.cargoRequestId)">…</span>
              </ng-template>
            </td>
            <td class="pp-num pp-nowrap">{{ money(bid.price, bid.currencyCode) }}</td>
            <td class="pp-nowrap">{{ bid.deliveryDays }} {{ daysText }}</td>
            <td>
              <span class="pp-badge" [ngClass]="'pp-badge--' + bidTone(bid)">{{ getBidStatusText(bid) }}</span>
              <small *ngIf="bid.bidStatus === 'LOST' && bid.pricePosition" class="price-position">
                {{ t('ffDash.rank', '{pos}-е место по цене').replace('{pos}', '' + bid.pricePosition) }}
              </small>
            </td>
            <td class="pp-muted pp-nowrap">{{ formatDate(bid.createdAt) }}</td>
            <td class="pp-right">
              <span class="row-arrow" *ngIf="!isRequestGone(bid.cargoRequestId)" aria-hidden="true">
                <svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg>
              </span>
            </td>
          </tr>
          <tr *ngIf="filteredBids.length === 0">
            <td colspan="7" class="pp-empty">{{ t('ffDash.noBidsInFilter', 'Нет ставок с таким статусом') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination
      *ngIf="bidsPage"
      [number]="bidsPage.number"
      [totalPages]="bidsPage.totalPages"
      [size]="bidsPage.size"
      [totalElements]="bidsPage.totalElements"
      [hasNext]="bidsPage.hasNext"
      [hasPrevious]="bidsPage.hasPrevious"
      (pageChange)="onBidsPageChange($event)"
    ></app-pagination>
  </ng-container>
</section>

<!-- Вкладка «Мои сделки» -->
<section *ngIf="activeTab === 'deals'" class="pp-card">
  <div class="ff-assign-filter" *ngIf="showOperatorColumn">
    <app-assignee-filter *ngIf="showManagerColumn" kind="manager" [value]="dealManagerFilter"
                         (changed)="dealManagerFilter = $event; onDealFilterChange()"></app-assignee-filter>
    <app-assignee-filter kind="operator" [value]="dealOperatorFilter"
                         (changed)="dealOperatorFilter = $event; onDealFilterChange()"></app-assignee-filter>
  </div>
  <div *ngIf="loadingDeals" class="pp-loading">{{ loadingText }}</div>
  <div *ngIf="errorDeals" class="pp-error">{{ errorDeals }}</div>
  <div *ngIf="!loadingDeals && !errorDeals && deals.length === 0" class="pp-empty">{{ noDealsText }}</div>

  <ng-container *ngIf="!loadingDeals && !errorDeals && deals.length > 0">
    <div class="pp-table-wrap">
      <table class="pp-table deals-table" appResizableColumns="ff-deals">
        <thead>
          <tr>
            <th>{{ dealNumberText }}</th>
            <th>{{ t('ffDash.requestRoute', 'Запрос и маршрут') }}</th>
            <th>{{ t('ffDeal.client', 'Клиент') }}</th>
            <th>{{ t('ffDash.price', 'Ставка') }}</th>
            <th *ngIf="showManagerColumn">{{ t('company.assign.managerColumn', 'Менеджер') }}</th>
            <th *ngIf="showOperatorColumn">{{ t('company.assign.operatorColumn', 'Оператор') }}</th>
            <th>{{ t('ffDash.stage', 'Текущий этап') }}</th>
            <th>{{ t('ffDash.dealDate', 'Сделка от') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deal of deals" class="bid-row" (click)="viewDeal(deal.id)">
            <td class="pp-num pp-nowrap">{{ deal.id | docNo:'D':deal.createdAt }}</td>
            <td class="route-cell">
              <small>{{ deal.cargoRequestId | docNo:'R':(requests[deal.cargoRequestId]?.createdAt || deal.createdAt) }}</small>
              <ng-container *ngIf="requests[deal.cargoRequestId] as r; else dealNoRoute">
                <strong [attr.title]="r.fromCity + ' → ' + r.toCity">{{ r.fromCity }} → {{ r.toCity }}</strong>
                <span>{{ countryName(r.fromCountryId) }} → {{ countryName(r.toCountryId) }}</span>
              </ng-container>
              <ng-template #dealNoRoute>
                <span class="route-cell__gone" *ngIf="isRequestGone(deal.cargoRequestId)">{{ t('ffDash.requestGone', 'Запрос удалён клиентом') }}</span>
              </ng-template>
            </td>
            <td class="client-cell">{{ deal.cargoOwnerCompanyName }}</td>
            <td class="pp-num pp-nowrap">
              <ng-container *ngIf="dealInfo[deal.id]?.price as price">{{ price }}</ng-container>
              <span class="pp-muted" *ngIf="!dealInfo[deal.id]">…</span>
            </td>
            <td *ngIf="showManagerColumn" class="pp-nowrap">{{ deal.managerName || '—' }}</td>
            <td *ngIf="showOperatorColumn" class="pp-nowrap">{{ deal.operatorName || '—' }}</td>
            <td class="stage-cell">
              <ng-container *ngIf="dealInfo[deal.id] as info; else stageLoading">
                <strong>{{ info.stage }}</strong>
                <span class="is-due" *ngIf="!info.updatedToday && !info.delivered">{{ t('ffDash.notUpdatedToday', 'сегодня не обновлялся') }}</span>
              </ng-container>
              <ng-template #stageLoading><span class="pp-muted">…</span></ng-template>
            </td>
            <td class="pp-muted pp-nowrap">{{ formatDate(deal.createdAt) }}</td>
            <td class="pp-right">
              <span class="row-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination
      *ngIf="dealsPage"
      [number]="dealsPage.number"
      [totalPages]="dealsPage.totalPages"
      [size]="dealsPage.size"
      [totalElements]="dealsPage.totalElements"
      [hasNext]="dealsPage.hasNext"
      [hasPrevious]="dealsPage.hasPrevious"
      (pageChange)="onDealsPageChange($event)"
    ></app-pagination>
  </ng-container>
</section>
